import { makeStyles } from '@material-ui/core';

export const editarCartaoStyles = makeStyles({
  cardButton: {
    padding: 0,
    width: 52,
    height: 52,
    // '& img': {
    //   filter: 'grayscale(100%)',
    // },
    // '&.Mui-selected': {
    //   '& img': {
    //     filter: 'grayscale(0%)',
    //   },
    // },
  },
});
